import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TreeNodeComponent, TreeNode } from "../tree-node/tree-node.component";

@Component({
  selector: 'app-tree-view',
  standalone: true,
  imports: [CommonModule, TreeNodeComponent],
  templateUrl: './tree-view.component.html',
})
export class TreeViewComponent {
  @Input() treeData!: TreeNode;
  @Output() selectedDataChange = new EventEmitter<TreeNode>();

  onSelectionChange() {
    this.selectedDataChange.emit(this.treeData);
  }
}
